<template>
    <div>
        
        <InfoBox modalName="HotspotGruende">
            
            <template #title>Gründe für die Explosion</template>
            <template #subline></template>
            <template>
                <p> Eigentlich ist nur ein <strong>routinemäßiger Sicherheitstest</strong> vorgesehen.
                In Block 4 soll ein <strong>Stromausfall simuliert</strong> werden. Der zuständige
                Schichtleiter aber verstößt mehrmals gegen <strong>Betriebsvorschriften</strong>.
                Eine Kettenreaktion kommt in Gang. <strong>Mängel am Reaktor</strong> und <strong>menschliches Versagen</strong> führen zur Katastrophe.
                <p>

                <!--<FullscreenImage v-bind:src="require('../assets/img/dummy-fullscreen.jpg')">-->
                <FullscreenImage v-bind:src="'img/00-382077_Reaktor4.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/thumb_00-382077_Reaktor4.jpg" alt="">
                        <figcaption>&copy;ap</figcaption>
                    </figure>
                </FullscreenImage> 

                <p>


            <p> Unter den Trümmern werden mehr als 200 Tonnen <strong>Uran</strong> begraben und etwa eine Tonne andere radioaktive Stoffe, vor allem
            <strong>ultragiftiges Plutonium</strong>. Diese Stoffe gilt es vor der Umwelt einzuschließen.
            </p>
            <p>

                            <!--<FullscreenImage v-bind:src="require('../assets/img/dummy-fullscreen.jpg')">-->
                <FullscreenImage v-bind:src="'img/16-1078488zerstoerter_reaktor_4.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/thumb_16-1078488zerstoerter_reaktor_4.jpg" alt="">
                        <figcaption>&copy;dpa</figcaption>
                    </figure>
                </FullscreenImage>
            </p>



            </template>
        </InfoBox>
        
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/03_Gruende_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/03_Gruende_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>          
            <div class="hotspot" v-on:click="infobox('HotspotGruende')"></div>	
        </Fallback>

    </div>
</template>

<script>
    export default {
        name: 'intro2',
        babylonState: {
            moveCamera: [-7, .8 , 8, 13, 2, 0],    //Stand deploy:[-9.8, .6 , 9, 13, 2, 0],  
            
            Geo_Tschernobyl: {
                children: {
                    BG_Sphere: true,
                },
            },

            hotspot: {
                visible: true,
                infoBox: 'HotspotGruende', // Muss zur Infobox oben passen!
                position: [13, 4.5, 0],

                //scale: 0,
               scale: 1,
            },

            Geo_Explosion: true,

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);
            this.$babylonController.setAutoRotateBehaviour(true),
            this.$babylonController.setCameraRadiusLimit (5,110),
            this.$babylonController.zoomCamera(0.8)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
